import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function CleaningBookingSuccess() {
  const [searchParams] = useSearchParams();
  const isCorporateBooking = searchParams.get('payment_status') === 'corporate_billing';

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="cleaning-booking-success">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-emerald-500" />
        </div>
        <h1 className="text-3xl font-bold text-slate-900 font-['Outfit'] mb-3">Booking Confirmed!</h1>
        <p className="text-slate-500 mb-8" data-testid="cleaning-booking-success-message">
          {isCorporateBooking
            ? "Your corporate booking has been submitted successfully. We'll bill your corporate account directly and follow up with your appointment details."
            : "Thank you for choosing Platinum Touch Car Cleaning. We'll contact you to confirm your appointment details."}
        </p>
        <Link to="/cleaning">
          <Button className="bg-emerald-500 hover:bg-emerald-600 text-white px-8">Back to Car Cleaning</Button>
        </Link>
      </div>
    </div>
  );
}
